const GlobeIcon = ({ height = 16, width = 16, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 0.583008C12.0959 0.583184 15.4158 3.90415 15.416 8C15.4158 12.0959 12.0959 15.4158 8 15.416C3.90415 15.4158 0.583184 12.0959 0.583008 8C0.583184 3.90415 3.90415 0.583184 8 0.583008ZM2.13281 8.75C2.42712 11.0753 4.06903 12.9792 6.25293 13.6533C5.30586 12.188 4.73983 10.5026 4.61328 8.75H2.13281ZM11.3857 8.75C11.2593 10.5027 10.694 12.188 9.74707 13.6533C11.931 12.9793 13.573 11.0754 13.8672 8.75H11.3857ZM6.11523 8.75C6.26215 10.4913 6.91741 12.1514 7.99902 13.5225C9.08108 12.1512 9.73773 10.4916 9.88477 8.75H6.11523ZM6.25195 2.3457C4.06849 3.02012 2.42719 4.92505 2.13281 7.25H4.61328C4.73987 5.49736 5.30491 3.81107 6.25195 2.3457ZM7.99902 2.47656C6.91721 3.8477 6.26219 5.50844 6.11523 7.25H9.88477C9.7377 5.5083 9.08113 3.84782 7.99902 2.47656ZM9.74805 2.3457C10.6949 3.81111 11.2592 5.49729 11.3857 7.25H13.8672C13.5729 4.92495 11.9315 3.02006 9.74805 2.3457ZM0.00976562 0.00976562H0V0H0.00976562V0.00976562Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default GlobeIcon;
